import router from "@/router"
import { login, logout } from "@/api/auth"
import { getToken, setToken, removeToken } from "@/utils/token"

export default {
  namespaced: true,
  state: () => ({
    token: getToken() || null,
    userInfo: null,
    loginTime: null,
    tokenExpire: null // TODO 如有需要，可结合后端返回的过期时间补齐续期相关逻辑  --Lix
  }),
  getters: {
    isLogged: state => !!state.token,
    currentUser: state => state.userInfo,
    loginDuration: state => (state.loginTime ? Math.floor((Date.now() - state.loginTime) / 1000) : 0)
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = Object.freeze(userInfo)
    },
    SET_LOGIN_TIME: state => {
      state.loginTime = new Date().getTime()
    },
    CLEAR_AUTH: state => {
      state.token = null
      state.userInfo = null
      state.loginTime = null
      removeToken()
    }
  },
  actions: {
    async login({ commit }, datas) {
      try {
        console.log("datas= ", datas)
        const res = {
          data: {
            _id: "67c950fa4052e6000a7e30c4",
            email: datas.login_name + "@carrier.com",
            userName: datas.login_name,
            role: ["Super_Admin"],
            menuPath: null,
            language: "English",
            token: "67c950fa4052e6000a7e30c4:1748566616:4723:97f608d995ae5967dcbf29b8cd3f820192c4469dfdd06726cce19249ce1c6d27"
          }
        }
        await login(datas)
        commit("SET_TOKEN", res.data.token)
        commit("SET_USER_INFO", { ...res.data })
        commit("SET_LOGIN_TIME")
        router.replace(router.currentRoute.query.redirect || "/loading")
        return res
      } catch (error) {
        removeToken()
        return Promise.reject(error)
      }
    },

    saveloginInfoByOkta({ commit }, data) {
      console.log("saveloginInfoByOkta", data)
      try {
        commit("SET_TOKEN", data.token)
        commit("SET_USER_INFO", { ...data })
        commit("SET_LOGIN_TIME")
      } catch (error) {
        console.log("saveloginInfoByOkta-error", error)
        removeToken()
      }
    },

    async logout({ commit }) {
      try {
        router.push("/login")
        // await logout()
      } finally {
        commit("CLEAR_AUTH")
      }
    },

    // TODO 如有需要，可结合后端返回的过期时间补齐续期相关逻辑  --Lix
    async refreshToken({ commit, state }) {
      if (!state.token) return
      const { data } = await refreshTokenAPI(state.token)
      commit("SET_TOKEN", data.newToken)
      return data.newToken
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js